<app-custom-modal title='{{"DataStoreFormPage.CreateData"|translate}}'
    subtitle='{{"DataStoreFormPage.DesignDataSubTitle"|translate}}' img="/assets/images/designData.png">
    <div header-buttons style="display: flex;">
        <div class="preview-button-2">
            <div (click)="codeSelectionWarn(false)" [ngClass]="{'active':!codeScreen}">
                {{"DataStoreFormPage.Form" | translate}}
            </div>
            <div (click)="codeSelectionWarn(true)" [ngClass]="{'active':codeScreen}">
                {{ "DataStoreFormPage.Code" |translate}}
            </div>
        </div>
    </div>
    <div body class="modal-body">
        <div class="main-container">
            <div class="code-container" *ngIf="codeScreen">
                <div style="display: flex;justify-content: end;align-items: center;">
                    <div>
                        <button *ngIf="this.customizeCode" mat-button (click)="resetCode()">
                            {{ 'Common.Reset' | translate }}
                        </button>
                        <button mat-button (click)="getSampleData()">
                            <mat-icon>play_arrow</mat-icon>
                            {{ 'WidgetFormPage.ExecuteQuery' | translate}}
                        </button>
                    </div>
                </div>
                <ngx-monaco-editor style="width: 100%;"
                    [style.Height]="rowData.length>0?'calc(50% - 40px)':'calc(100% - 40px)'" class="editor"
                    [options]="editorOptions" [(ngModel)]="code"></ngx-monaco-editor>

                <div class="table-container" *ngIf="rowData.length>0">
                    <app-ag-grid-table [columnTypes]="columnTypes" [rowData]="rowData"></app-ag-grid-table>
                </div>
            </div>
            <div class="form-container" *ngIf="!codeScreen">
                <form [formGroup]="DBViewForm">
                    <mat-form-field>
                        <mat-label>{{ "DataStoreFormPage.ViewName" | translate }}</mat-label>
                        <input matInput formControlName="viewName" />
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>{{ "DataStoreFormPage.DataStores" | translate }}</mat-label>
                        <mat-select formControlName="dataStoreId" (selectionChange)="changeDataStoreSelection()">
                            <mat-option *ngFor="let ds of dataStores" [value]="ds.dataStoreId">
                                {{ ds.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div style="display: flex;gap: 10px;">
                        <div class="selection-container">
                            <mat-label>{{"DataStoreFormPage.Collections" | translate}}</mat-label>
                            <mat-selection-list class="selection-list" [(ngModel)]="selectedCollections"
                                (selectionChange)="changeCollection($event)" [ngModelOptions]="{standalone:true}">
                                <div *ngIf="collections.length<=0"
                                    style="display: flex;align-items: center;justify-content: center;height: 100%;width: 100%;">
                                    {{"Common.EmptyData" | translate}}
                                </div>
                                <mat-list-option *ngFor="let item of collections" [value]="item.collectionName"
                                    (selectedChange)="changeSelectionForList(item,$event,'collection')">
                                    <div>
                                        {{item.collectionName}}
                                        <button mat-button [matMenuTriggerFor]="menu"
                                            (click)="$event.stopPropagation();" color="primary"
                                            *ngIf="item.selected">{{item.joinType||'joinType'}}</button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item *ngFor="let jt of joinTypeSelect"
                                                (click)="selectJoinType(item,jt)"
                                                [ngClass]="{'active-menu':item.joinType == jt.value}">
                                                {{jt.text}}
                                            </button>
                                        </mat-menu>


                                        <button mat-button [matMenuTriggerFor]="colmenu" color="primary"
                                            *ngIf="item.joinType.includes('Join')" (click)="$event.stopPropagation();">
                                            <div *ngIf="item.joinColumn.destination.length<=0||item.joinColumn.source.length<=0"
                                                class="custom-badge"></div>
                                            {{'Join Column'}}
                                        </button>
                                        <mat-menu #colmenu="matMenu">
                                            <div style="padding: 10px;" (click)="$event.stopPropagation()">
                                                <mat-form-field>
                                                    <mat-label>{{"DataStoreFormPage.Source"|translate}}</mat-label>
                                                    <mat-select
                                                        (selectionChange)="joinColumnSelection($event,item,'source')"
                                                        [value]="item.joinColumn.source">
                                                        <mat-option *ngFor="let col of columns[mainCollectionName]"
                                                            [value]="col.visibleName">{{col.visibleName}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <mat-form-field>
                                                    <mat-label>{{"DataStoreFormPage.Destination"|translate}}</mat-label>
                                                    <mat-select
                                                        (selectionChange)="joinColumnSelection($event,item,'destination')"
                                                        [value]="item.joinColumn.destination">
                                                        <mat-option *ngFor="let col of columns[item.collectionName]"
                                                            [value]="col.visibleName">{{col.visibleName}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </mat-menu>
                                    </div>

                                </mat-list-option>
                            </mat-selection-list>
                        </div>

                        <div class="selection-container">
                            <mat-label>{{"DataStoreFormPage.Columns" | translate}}</mat-label>
                            <!-- todo custom selectionList -->
                            <mat-selection-list class="selection-list" [(ngModel)]="selectedColumns"
                                [ngModelOptions]="{standalone:true}">
                                <div *ngIf="columnCount<=0"
                                    style="display: flex;align-items: center;justify-content: center;height: 100%;width: 100%;">
                                    {{"Common.EmptyData" | translate}}
                                </div>
                                <div *ngFor="let item of selectedCollections">
                                    <mat-list-option *ngFor="let column of columns[item]"
                                        (selectedChange)="changeSelectionForList(column,$event,'column')"
                                        [value]="column.visibleName">
                                        <div>
                                            {{column.visibleName}}
                                            <button (click)="$event.stopPropagation()" mat-button
                                                [matMenuTriggerFor]="asNameMenu" color="primary"
                                                *ngIf="column.selected">
                                                {{'As '+column.asName}}
                                            </button>

                                            <mat-menu #asNameMenu="matMenu" (closed)="asNameChange(column)">
                                                <div style="padding: 10px;" (click)="$event.stopPropagation()">
                                                    <mat-form-field>
                                                        <mat-label>As Name</mat-label>
                                                        <input matInput [(ngModel)]="column.asName"
                                                            [ngModelOptions]="{standalone:true}">
                                                    </mat-form-field>
                                                </div>
                                            </mat-menu>
                                        </div>


                                    </mat-list-option>
                                </div>
                            </mat-selection-list>
                        </div>

                    </div>

                </form>
                <div *ngIf="selectionListErrorText.length>0" class="error-text">*{{selectionListErrorText}}</div>
                <div class="condition-area" *ngIf="columnCount>0">
                    <div class="condition-button-container">
                        <div>
                            <h3 style="margin: 0;margin-left: 5px;" *ngIf="conditionForms.length>0">Conditions</h3>
                        </div>
                        <button mat-stroked-button class="custom-primary-stroked-button"
                            (click)="addConditionFormGroup()">
                            {{"DataStoreFormPage.AddCondition" | translate}}
                        </button>
                    </div>
                    <div class="condition-form" *ngFor="let frm of conditionForms">

                        <form [formGroup]="frm.formGroup">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ "DataStoreFormPage.Columns" | translate }}</mat-label>
                                <mat-select formControlName="column" (selectionChange)="changeConditionColumn(frm)">
                                    <div *ngFor="let selectedcollection of selectedCollections">
                                        <mat-option *ngFor="let col of columns[selectedcollection]"
                                            [value]="col.visibleName">
                                            {{ col.visibleName }}
                                        </mat-option>
                                    </div>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "FilterComponent.Operator" | translate }}</mat-label>
                                <mat-select formControlName="operator">
                                    <mat-option *ngFor="let op of conditionOperators" [value]="op.value">
                                        {{ op.text |translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>{{ "FilterComponent.Value" | translate }}</mat-label>
                                <input formControlName="value" matInput [type]="frm.type" />
                            </mat-form-field>
                            <div class="condition-delete-container">
                                <mat-icon svgIcon="delete-box" (click)="deleteCondition(frm)"></mat-icon>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>

        <div class="buttons-container">
            <button mat-stroked-button class="custom-primary-stroked-button" (click)="saveDesignedData()">
                {{"Common.Save"|translate}}
            </button>
        </div>

    </div>
</app-custom-modal>